import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, timeout: 15000 });

export const endpoints = {
  siteSettings: () => api.get("/site-settings").then(r => r.data),
  conditions: () => api.get("/conditions").then(r => r.data),
  condition: (slug) => {
    const preview = new URLSearchParams(window.location.search).get("preview");
    return api.get(`/conditions/${slug}`, { params: preview ? { preview } : {} }).then(r => r.data);
  },
  articles: (category) => api.get("/articles", { params: category ? { category } : {} }).then(r => r.data),
  article: (slug) => {
    const preview = new URLSearchParams(window.location.search).get("preview");
    return api.get(`/articles/${slug}`, { params: preview ? { preview } : {} }).then(r => r.data);
  },
  journeys: () => api.get("/journeys").then(r => r.data),
  journey: (slug) => api.get(`/journeys/${slug}`).then(r => r.data),
  guidelines: () => api.get("/guidelines").then(r => r.data),
  research: (type) => api.get("/research", { params: type ? { type } : {} }).then(r => r.data),
  testimonials: () => api.get("/testimonials").then(r => r.data),
  createEnquiry: (payload) => api.post("/enquiries", payload).then(r => r.data),
  search: (q) => api.get("/search", { params: { q } }).then(r => r.data),
  seed: () => api.post("/admin/seed").then(r => r.data),
};
